import { Component } from '@angular/core';
import { licenseActions } from '@src/store/reducers/licenseReducer';
import { Store } from '@src/store';
import { SessionService } from '@src/services';

const ignoreWarningsKey = 'ignoreWarnings';
const warningKey = 'warning';
@Component({
    selector : 'license-dialog',
    template: require('./license-dialog.component.html'),
    styles: [require('./license-dialog.component.scss')]
})
export class LicenseDialogComponent {

    public warning: any;
    public warningKey: String = 'warning';
    public ignoreWarnings: any[];
    public notificationWindow: boolean = false;
    private unSubscribe: any;

    constructor(
        private sessionService : SessionService,
        private store : Store) {
        this.unSubscribe = this.store.subscribe(() => {
            if (this.store.getState().license.warningText) {
                this.sessionService.set(warningKey, this.store.getState().license.warningText);
                this.warning = this.sessionService.get(warningKey);
            }
        });
        this.ignoreWarnings = this.sessionService.get(ignoreWarningsKey);
        if (this.ignoreWarnings == null) {
            this.ignoreWarnings = [];
        }
    }
    public ngOnDestroy() {
        this.unSubscribe();
    }
    public addIgnoreWarning(item) {
        if (this.ignoreWarnings.findIndex(i => i.Key === item.Key) === -1) {
            this.ignoreWarnings.push(item);
        }
        this.sessionService.set(ignoreWarningsKey, this.ignoreWarnings);
        this.store.dispatch({
            type: licenseActions.SET_LICENSE_IGNORE_WARNINGS,
            payload: { ignoreWarningText: this.ignoreWarnings }
        });
    }
    public checkIgnoreWarnings(item) {
        if (!this.ignoreWarnings || this.ignoreWarnings.length === 0) {
            return true;
        }
        return (this.ignoreWarnings.findIndex(i => i.Key === item.Key) === -1);
    }

    public isWarningsContainerEmpty() {
        let result = true;
        if (!this.warning) {
            return result;
        }
        result = !(this.warning.some((warn: String) => {
            return this.checkIgnoreWarnings(warn);
        }));
        return result;
    }
    public openLicenseMenu() {
        this.notificationWindow = !this.notificationWindow;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/top-bar/license-Dialog/license-dialog.component.ts